module.exports = __webpack_public_path__ + "img/ic_alphabet-list.f8ec0ade.svg";